import React, { useState, useEffect } from 'react';
import BrokerPanel from './Panel';
import BrokerViewPanel from './BrokerView';
import { TrashIcon } from '../../../../img/findcare/FindCareSVG';

const BrokerFilterPanel = ({
  label,
  onSelectedBrokersCount,
  onSelectedBrokers,
  createUserFormData,
  onSetAllBrokers,
  selectedBrokerData,
  editAffiliatedRecords,
}) => {
  const [selectedBroker, setSelectedBroker] = useState(
    selectedBrokerData && selectedBrokerData.length > 0
      ? selectedBrokerData
      : createUserFormData.brokers,
  );
  const [deleteBrokerId, setDeleteBrokerId] = useState('');

  const onSelectedBrokerHandler = (selectedBrokerLists) => {
    setSelectedBroker(selectedBrokerLists);
  };

  const onTrashButtonClickHandler = (brokerId) => {
    setDeleteBrokerId(brokerId);
  };

  useEffect(() => {
    onSelectedBrokersCount(selectedBroker.length);
    onSelectedBrokers(selectedBroker);
  }, [selectedBroker]);

  useEffect(() => {
    if (selectedBrokerData && selectedBrokerData.length > 0) {
      setSelectedBroker(selectedBrokerData);
    }
  }, [selectedBrokerData]);

  console.log('selectedBroker::::::::::', selectedBroker);
  return (
    <>
      <BrokerPanel
        label={label}
        deleteBrokerId={deleteBrokerId}
        onSelectedBrokerHandler={onSelectedBrokerHandler}
        createUserFormData={createUserFormData}
        onSetAllBrokers={onSetAllBrokers}
        selectedBrokerData={selectedBrokerData}
        editAffiliatedRecords={editAffiliatedRecords}
      />
      <div className="mt-2">
        <BrokerViewPanel
          selectedBrokers={selectedBroker}
          onTrashButtonClickHandler={onTrashButtonClickHandler}
          editAffiliatedRecords={editAffiliatedRecords}
        />
      </div>
    </>
  );
};

export default BrokerFilterPanel;
